<template>
  <callout
    border-color="primary-2"
    class="mb-4"
    :controlled="true"
    :has-toggle="false"
  >
    <validation-observer ref="formValidator">
      <icon-view
        class="icon-view__extended"
        icon="fas fa-file-plus"
        icon-background="#FF7058"
        icon-color="#fff"
        icon-size="18px"
        title="Razón de Addendum"
      />
      <div class="row mt-3">
        <div v-if="!readOnly" class="col d-flex align-items-end">
          <custom-drop-down
            v-model="reasonSelected"
            class="w-30"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            label="Razón:"
            :options="addendumReasonsOptions"
            placeholder="Seleccione"
          />
          <action-button
            class="ml-2"
            i="fas fa-file-plus"
            variant="success"
            @click="addReason()"
          >
            Añadir
          </action-button>
        </div>
        <div class="col-md-12">
          <custom-chips-group
            class="mt-n3"
            :disabled="readOnly"
            no-background
            :no-wrap="true"
            object-text="name"
            :on-item-deleted="onDeleteItemHandler"
            :selected-items="model.addendumReasons"
            title="Razón(es) Seleccionada(s):"
          />
        </div>
        <div class="col-md-12">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <custom-text-area
              v-model="model.comment"
              custom-error-msg="Favor completar comentario."
              :disabled="readOnly"
              :error="errors[0]"
              label="Comentario:"
              :maxlength="3000"
              name="comment"
              :rows="3"
            />
          </validation-provider>
        </div>

        <div
          v-if="!readOnly"
          class="col mt-3 mb-3 d-flex align-items-end justify-content-end"
        >
          <action-button
            i="fas fa-times-circle"
            variant="btn btn-outline-danger btn-cancel danger"
            @click="handleCancel"
          >
            Cancelar
          </action-button>
          <action-button
            class="ml-3"
            i="far fa-arrow-circle-right"
            variant="success"
            @click="handleContinue"
          >
            Continuar
          </action-button>
        </div>
      </div>
    </validation-observer>
  </callout>
</template>

<script>
import IconView from 'icon-view';
import Callout from 'custom-callout';
import CustomChipsGroup from 'CustomChipsGroup';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

const ADDENDUM_REASONS = [
  {
    id: 'title',
    name: 'Título',
    order: 1,
  },
  {
    id: 'minimumScore',
    name: 'Puntuación Mínima',
    order: 2,
  },
  {
    id: 'region',
    name: 'Región',
    order: 3,
  },
  {
    id: 'dates',
    name: 'Fechas',
    order: 4,
  },
  {
    id: 'description',
    name: 'Descripción',
    order: 5,
  },
  {
    id: 'documents',
    name: 'Documentos',
    order: 6,
  },
  {
    id: 'contact',
    name: 'Contacto',
    order: 7,
  },
];

export default {
  name: 'AddAddendum',
  components: {
    IconView,
    CustomDropDown,
    Callout,
    CustomChipsGroup,
    ActionButton,
    CustomTextArea,
  },
  mixins: [alertMixin],
  data() {
    return {
      readOnly: false,
      reasonSelected: null,
      addendumReasonsOptions: [...ADDENDUM_REASONS],
      model: {
        comment: null,
        addendumReasons: [],
      },
    };
  },
  methods: {
    onDeleteItemHandler(elem) {
      const index = this.model.addendumReasons.findIndex(
        (y) => y.id === elem.id
      );
      this.model.addendumReasons.splice(index, 1);

      this.addendumReasonsOptions.push(elem);

      this.addendumReasonsOptions.sort((a, b) => a.order - b.order); // Sorts by age in ascending order
    },
    addReason() {
      if (!this.reasonSelected) return;

      this.model.addendumReasons.push(this.reasonSelected);
      const index = this.addendumReasonsOptions.findIndex(
        (y) => y.id === this.reasonSelected.id
      );
      this.addendumReasonsOptions.splice(index, 1);
      this.reasonSelected = null;
    },
    handleCancel() {
      this.$emit('on-cancel');
    },
    async handleContinue() {
      if (this.model.addendumReasons.length === 0) {
        this.ShowToast(
          'Atención',
          'Por favor seleccione al menos una razón',
          'error'
        );
        return;
      }

      const isValid = await this.$refs.formValidator.validate();
      if (!isValid) return;

      this.$emit('on-continue', this.model);
      this.readOnly = true;
    },
  },
};
</script>

<style scoped lang="scss">
.icon-view__extended {
  ::v-deep {
    .dot {
      width: 34px;
      height: 34px;
    }
  }
}
</style>
